module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"successMessageUpdated":"ID Consegna aggiornato","addDialogHeader":"","editDialogHeader":"Modifica ID Consegna","formExternalInvoiceId":{"ExternalInvoiceId":"ID Consegna"}}}')
  delete Component.options._Ctor
}
